"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signEncodedPayload = exports.getDidUniqueSuffix = exports.encodeJson = void 0;
/* eslint-disable arrow-body-style */
const create_hash_1 = __importDefault(require("create-hash"));
const secp256k1 = __importStar(require("secp256k1"));
const base64url = require('base64url');
const multihashes = require('multihashes');
const sha256 = (data) => {
    return create_hash_1.default('sha256').update(data).digest();
};
exports.encodeJson = (payload) => base64url.encode(Buffer.from(JSON.stringify(payload)));
const decodeJson = (encodedPayload) => JSON.parse(base64url.decode(encodedPayload));
const payloadToHash = (payload) => {
    const encodedPayload = exports.encodeJson(payload);
    const encodedOperationPayloadBuffer = Buffer.from(encodedPayload);
    const hash = sha256(encodedOperationPayloadBuffer);
    const hashAlgorithmName = multihashes.codes[18]; // 18 is code for sha256
    const multihash = multihashes.encode(hash, hashAlgorithmName);
    return base64url.encode(multihash);
};
exports.getDidUniqueSuffix = (operation) => {
    const header = decodeJson(operation.protected);
    switch (header.operation) {
        case 'create':
            return payloadToHash(operation.payload);
        case 'update':
        case 'recover':
        case 'delete':
            return decodeJson(operation.payload).didUniqueSuffix;
        default:
            throw Error(`Cannot extract didUniqueSuffixe from: ${operation}`);
    }
};
// NOTE check is signatures are the same as sidetree's (see NEP-334)
exports.signEncodedPayload = (encodedHeader, encodedPayload, privateKey) => {
    const toBeSigned = `${encodedHeader}.${encodedPayload}`;
    const hash = sha256(toBeSigned);
    const privateKeyBuffer = Buffer.from(privateKey, 'hex');
    const signatureObject = secp256k1.ecdsaSign(hash, privateKeyBuffer);
    return base64url.encode(signatureObject.signature);
};
//# sourceMappingURL=func.js.map